import { atom } from "@byko/lib-recoil";

export const errorMessageState = atom({
  key: "error-message",
  default: "" as string,
});
